import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import { common } from '@mui/material/colors';
import { BaseCheckbox } from 'common/components/base-checkbox-group';
import { colors } from 'common/constants';
import React from 'react';
interface Props {
    name: string;
    options: boolean[];
    rowsTitle: string[];
    columnsTitle: string[];
    matrixAnswerType?: string;
}
const QuestionMatrixCheckbox: React.FC<Props> = ({
    name,
    rowsTitle = [],
    columnsTitle = [],
    matrixAnswerType = 'row',
}) => {
    const displayMobileRowTitle =
        matrixAnswerType === 'row' ? rowsTitle : columnsTitle;
    const displayMobileColumnTitle =
        matrixAnswerType === 'row' ? columnsTitle : rowsTitle;
    return (
        <Box>
            <Table
                sx={{
                    backgroundColor: common.white,
                    display: ['none', 'table'],
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{
                                border: `2px solid ${colors.main}`,
                            }}
                        />
                        {columnsTitle.map((option, index) => (
                            <TableCell
                                key={`table-header-${index}`}
                                align="center"
                                sx={{
                                    border: `2px solid ${colors.main}`,
                                    fontSize: [
                                        '1rem',
                                        '1rem',
                                        '1rem',
                                        '2rem',
                                        '2rem',
                                    ],
                                    fontWeight: 500,
                                    lineHeight: '2rem',
                                }}
                            >
                                {option}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rowsTitle.map((question, rowIndex) => (
                        <TableRow
                            key={`table-row-${rowIndex}`}
                            sx={{
                                border: `2px solid ${colors.main}`,
                            }}
                        >
                            <TableCell
                                sx={{
                                    border: `2px solid ${colors.main}`,
                                    backgroundColor: common.white,
                                    fontSize: [
                                        '1rem',
                                        '1rem',
                                        '1rem',
                                        '2rem',
                                        '2rem',
                                    ],
                                    fontWeight: 500,
                                }}
                            >
                                {question}
                            </TableCell>
                            {columnsTitle.map((colVal, colIndex) => (
                                <TableCell
                                    key={`table-cell-${rowIndex}-${colIndex}`}
                                    align="center"
                                    sx={{
                                        border: `2px solid ${colors.main}`,
                                    }}
                                >
                                    <BaseCheckbox
                                        name={
                                            matrixAnswerType === 'row'
                                                ? `${name}[${rowIndex}][${colIndex}]`
                                                : `${name}[${colIndex}][${rowIndex}]`
                                        }
                                        label={undefined}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 28,
                                            },
                                        }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <Box
                sx={{
                    display: ['block', 'none'],
                }}
            >
                {displayMobileRowTitle.map((question, rowIndex) => (
                    <>
                        <Accordion
                            key={`accordion-${rowIndex}`}
                            disableGutters
                            square={true}
                            sx={{
                                backgroundColor: 'unset',
                                boxShadow: 'none',
                                border: 'none',
                                padding: 0,
                                fontSize: '1.2rem',
                                color: common.white,
                                fontWeight: 700,

                                borderBottom: `2px solid ${common.white}`,
                                '&::before': {
                                    display: 'none',
                                },
                            }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <ExpandMoreIcon
                                        sx={{
                                            fontSize: '3rem',
                                            color: common.white,
                                            transform: 'rotate(-90deg)',
                                            transition: 'transform 0.3s ease',
                                            '.Mui-expanded &': {
                                                transform: 'rotate(-180deg)',
                                            },
                                        }}
                                    />
                                }
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    padding: 0,
                                    marginBottom: '0.5rem',
                                    marginTop: '0.5rem',
                                }}
                            >
                                {question}
                            </AccordionSummary>
                            <AccordionDetails
                                sx={{
                                    padding: 0,
                                }}
                            >
                                {displayMobileColumnTitle.map(
                                    (item, colIndex) => {
                                        return (
                                            <BaseCheckbox
                                                key={`accordion-${rowIndex}-${colIndex}`}
                                                name={`${name}[${rowIndex}][${colIndex}]`}
                                                label={item}
                                                sx={{
                                                    backgroundColor: 'white',
                                                    width: '100%',
                                                    ml: 0,
                                                    mr: 0,
                                                    mb: '0.7rem',
                                                    padding: '8px',
                                                    color: 'black',
                                                }}
                                                sxCheckbox={{
                                                    '& .MuiFormControl-root': {
                                                        backgroundColor: '#fff',
                                                    },
                                                    '& .MuiFormControlLabel-label':
                                                        {
                                                            color: common.black,
                                                            fontWeight: '500',
                                                        },
                                                    '&.Mui-checked + .MuiFormControlLabel-label':
                                                        {
                                                            color: colors.main,
                                                            fontWeight: '500',
                                                        },
                                                }}
                                            />
                                        );
                                    }
                                )}
                            </AccordionDetails>
                        </Accordion>
                    </>
                ))}
            </Box>
        </Box>
    );
};

export default QuestionMatrixCheckbox;
